"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodashEs = require("lodash-es");
var _inventory = require("@/api/inventory");
var _sanner = _interopRequireDefault(require("@/utils/sanner"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var basicFormItem = {
  barcode: '',
  goodsId: undefined,
  goodsName: '',
  quantity: undefined,
  remark: '',
  // 辅助回滚结果
  _selectedGoodsName: '',
  _justSelected: false
};
var _default = exports.default = {
  name: 'BasicInOut',
  data: function data() {
    return {
      list: [],
      debounceFunc: null,
      scanner: null,
      editingCell: {
        rowIndex: null,
        field: ''
      }
    };
  },
  computed: {
    operationType: function operationType() {
      return this.$route.meta.title;
    }
  },
  mounted: function mounted() {
    console.log(this.$route);
    this.scannerInstall();
    this.onReset();
  },
  created: function created() {
    this.debounceFunc = (0, _lodashEs.debounce)(this.onGoodsSearch, 300);
  },
  methods: {
    scannerInstall: function scannerInstall() {
      var _this = this;
      if (!this.scanner) {
        this.scanner = new _sanner.default(function (code) {
          _this.scanActions(code);
        });
      }
      this.scanner.start();
    },
    scannerUninstall: function scannerUninstall() {
      if (this.scanner) {
        this.scanner.stop();
      }
    },
    scanActions: function scanActions(code) {
      console.log('code', code);
      if (this.list.length === 1 && !this.list[0].goodsId && !this.list[0].barcode) {
        var o = this.list[0];
        o.barcode = code;
        this.$set(this.list, 0, o);
      } else {
        var _o = Object.assign({}, basicFormItem);
        _o.barcode = code;
        this.list.push(_o);
        this.scrollToBottom();
      }
    },
    scrollToBottom: function scrollToBottom() {
      var _this2 = this;
      this.$nextTick(function () {
        var wrapper = _this2.$refs.tableRef.$el.querySelector('.el-table__body-wrapper');
        wrapper.scrollTop = wrapper.scrollHeight;
      });
    },
    onAddRow: function onAddRow() {
      this.list.push(Object.assign({}, basicFormItem));
    },
    onRemoveRow: function onRemoveRow(index) {
      if (index === 0 && this.list.length === 1) {
        this.$set(this.list, 0, Object.assign({}, basicFormItem));
      } else {
        this.list.splice(index, 1);
      }
    },
    onReset: function onReset() {
      this.list = [];
      this.list.push(Object.assign({}, basicFormItem));
    },
    onGoodsSearch: function () {
      var _onGoodsSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(querystring, callback, row) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _inventory.getInventoryGoodsSimpleList)(querystring);
            case 1:
              res = _context.v;
              callback(res);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('快速查询失败：', _t);
              callback([]);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      function onGoodsSearch(_x, _x2, _x3) {
        return _onGoodsSearch.apply(this, arguments);
      }
      return onGoodsSearch;
    }(),
    goodsSearchAsync: function goodsSearchAsync(querystring, callback, row) {
      if (!querystring) {
        callback([]);
        return;
      }
      this.debounceFunc(querystring, callback, row);
    },
    onGoodsSelect: function onGoodsSelect(item, row) {
      row.goodsName = item.name;
      row.goodsId = item.id;
      row._selectedGoodsName = item.name;
      row._justSelected = true;
      this.$nextTick(function () {
        row._justSelected = false;
      });
    },
    onGoodsClear: function onGoodsClear(row) {
      row.goodsName = '';
      row.goodsId = undefined;
      row._selectedGoodsName = '';
    },
    onGoodsNameInput: function onGoodsNameInput(val, row) {
      row.goodsName = val;
      if (val !== row._selectedGoodsName) {
        row.goodsId = undefined;
      }
    },
    handleGoodsBlur: function handleGoodsBlur(row, index) {
      if (row._justSelected) return;
      if (row.goodsName !== row._selectedGoodsName) {
        row.goodsId = undefined;
      }
      this.handleBlur(index, 'goodsName');
    },
    isEditing: function isEditing(index, field) {
      return this.editingCell.rowIndex === index && this.editingCell.field === field;
    },
    getInputRef: function getInputRef(rowIndex, field) {
      return "input-".concat(rowIndex, "-").concat(field);
    },
    enableEdit: function enableEdit(index, field) {
      var _this3 = this;
      if (this.isEditing(index, field)) return;
      this.editingCell = {
        rowIndex: index,
        field: field
      };
      this.$nextTick(function () {
        var refName = _this3.getInputRef(index, field);
        var inputRef = _this3.$refs[refName];
        var input = Array.isArray(inputRef) ? inputRef[0] : inputRef;
        if (input && input.focus) {
          input.focus();
        }
        if (input && input.$el) {
          var nativeInput = input.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.select();
          }
        }
      });
    },
    lockEdit: function lockEdit() {
      this.editingCell = {
        rowIndex: null,
        field: ''
      };
    },
    handleBlur: function handleBlur(index, field) {
      if (!this.isEditing(index, field)) return;
      this.lockEdit();
    },
    handleEnter: function handleEnter(index, field) {
      if (!this.isEditing(index, field)) return;
      this.lockEdit();
    },
    validateList: function validateList() {
      var list = this.list;
      for (var i = 0; i < list.length; i++) {
        var item = list[i] || {};
        var hasBarcode = !!String(item.barcode || '').trim();
        var hasGoodsId = item.goodsId !== undefined && item.goodsId !== null && item.goodsId !== '';
        if (!hasBarcode && !hasGoodsId) {
          var err = new Error("\u5E8F\u53F7 ".concat(i + 1, " \u7684\u8868\u683C\u9879\u4E0D\u5408\u6CD5\uFF1A\u3010\u5546\u54C1\u540D\u79F0\u3011 \u548C \u3010\u5546\u54C1\u6761\u7801\u3011 \u81F3\u5C11\u5B58\u5728\u4E00\u4E2A"));
          err.index = i;
          err.field = 'barcode|goodsId';
          throw err;
        }
        if (!(Number(item.quantity) > 0)) {
          var _err = new Error("\u5E8F\u53F7 ".concat(i + 1, " \u7684\u8868\u683C\u9879\u4E0D\u5408\u6CD5\uFF1A\u3010\u6570\u91CF\u3011 \u5FC5\u987B\u4E3A\u5927\u4E8E\u7B49\u4E8E1\u7684\u6B63\u6574\u6570"));
          _err.index = i;
          _err.field = 'quantity';
          throw _err;
        }
      }
      return true;
    },
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var func, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.validateList();
              func = this.$route.meta.bizType === 'IN' ? _inventory.batchInBound : _inventory.batchOutBound;
              _context2.n = 1;
              return func(this.list);
            case 1:
              this.$message.success("".concat(this.operationType, "\u6210\u529F"));
              this.onReset();
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.$message.error(_t2.message);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  },
  beforeDestroy: function beforeDestroy() {
    this.scannerUninstall();
  }
};